module.exports = __webpack_public_path__ + "media/images/courseware_completion_status_in_progress-c96e141f03eded999481ef1ef8f94934.png";